var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeWithCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9806 5.38062 18.6194 0.0193593 12 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39995 10.6003H7.59995C7.37904 10.6003 7.19995 10.7794 7.19995 11.0003V15.8003C7.19995 16.0212 7.37904 16.2003 7.59995 16.2003H8.79995V11.0003C8.79995 10.7794 8.62087 10.6003 8.39995 10.6003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9529 10.2535C15.8386 10.2182 15.7197 10.2002 15.6001 10.2003H13.2001V9.00025C13.2001 7.47065 12.1645 7.02345 11.6169 7.00025C11.5082 6.99643 11.4024 7.03634 11.3233 7.11105C11.2445 7.1866 11.2 7.29108 11.2001 7.40025V9.25545L9.6001 11.1755V16.2003H14.4921C15.02 16.2027 15.4868 15.8582 15.6401 15.3531L16.7477 11.7531C16.8412 11.4488 16.81 11.1199 16.6609 10.8386C16.5119 10.5574 16.2572 10.3469 15.9529 10.2535Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeWithCircle);
export default __webpack_public_path__ + "static/media/likeWithCircle.097c00bc.svg";
export { ForwardRef as ReactComponent };